import moment from 'moment'

const clientFullName = (name, lastName) => {
	lastName = lastName || ''
	return name ? name.concat(' ', lastName) : lastName;
};

const formatDate = (date) => {
	return date ? moment(date).format("DD MMMM YYYY") : null;
};

const formatOrderIdWithZero = (number, width) => {
	var numberOutput = Math.abs(number);
	var length = number.toString().length;
	var zero = "0";

	if (width <= length) {
	  if (number < 0) {
	    return ("-" + numberOutput.toString());
	  } else {
	    return numberOutput.toString();
	  }
	} else {
	  if (number < 0) {
	    return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
	  } else {
	    return ((zero.repeat(width - length)) + numberOutput.toString());
	  }
	}
};

const formatOrderNumber = (orderId, clientId) => {
	return formatOrderIdWithZero(orderId, 9) + '-' + clientId.toString();
};

export const formatReceivableList = receivableList => {
	return receivableList.map(receivable => ({
		'id': receivable.id,
		'partialOrderId': receivable.partial_order_id,
		'clientName': clientFullName(receivable.partial_order.client.name, receivable.partial_order.client.last_name),
		'phone': receivable.partial_order.client.phone,
		'openingDate': formatDate(receivable.opening_date),
		'deliveryDay': formatDate(receivable.partial_order.delivery_day) || 'FALTA AGENDAR',
		'total': receivable.total,
		'advancePayment': receivable.advance_payment,
		'pendingPayment': receivable.pending_payment,
		'orderId': receivable.partial_order.order_id,
		'status': receivable.status
	}));
};

export const formatReceivableDetailList = receivableDetailList => {
	return receivableDetailList.map(receivableDetail => ({
		'id': receivableDetail.id,
		'receivableId': receivableDetail.receivable_id,
		'payment': receivableDetail.payment,
		'paymentDate': formatDate(receivableDetail.payment_date)
	}));
};

export const formatReceivableModel = receivable => ({
	'id': receivable.id,
	'partialOrderId': receivable.partial_order_id,
	'total': receivable.total,
	'advancePayment': receivable.advance_payment,
	'pendingPayment': receivable.pending_payment,
	'orderId': receivable.partial_order.order_id,
	'status': receivable.status
});

export const formatPartialOrderModel = partialOrder => ({
	'id': partialOrder.id,
	'client_id': partialOrder.client_id,
	'address_id': partialOrder.address_id,
	'payment_type_id': partialOrder.payment_type_id,
	'shipping_type_id': partialOrder.shipping_type_id,
	'shipping_price': partialOrder.shipping_price,
	'subtotal': partialOrder.subtotal,
	'coupon': partialOrder.coupon,
	'total': partialOrder.total,
	'advance_payment': partialOrder.advance_payment,
	'pending_payment': partialOrder.pending_payment,
	'delivery_day': partialOrder.delivery_day,
	'coupon_code': partialOrder.coupon_code,
	'opening_date': partialOrder.opening_date
});

export const formatClientModel = client => ({
	'id': client.id,
	'email': client.email,
	'name': client.name,
	'last_name' : client.last_name,
	'identification_doc' : client.identification_doc,
	'phone': client.phone,
	'accept_conditions': client.accept_conditions,
	'status': client.status
});

export const formatAddressModel = address => ({
	'id': address.id,
	'shipping_type_id': address.shipping_type_id,
	'client_id': address.client_id,
	'department_id': address.department_id,
	'province_id': address.province_id,
	'district_id': address.district_id,
	'address': address.address,
	'reference': address.reference,
	'primary': address.primary,
	'status': address.status
});

export const formatPartialOrderDetailModel = partialOrderDetailList => {
	return partialOrderDetailList.map(detail => ({
		'id': detail.id,
		'product_id': detail.product_id,
		'product_color_id': detail.product_color_id,
		'product_color_size_id': detail.product_color_size_id,
		'product_name': detail.product.name,
		'product_color_name': detail.product_color.color.name,
		'product_color_size_name': detail.product_color_size.size.name,
		'quantity': detail.quantity,
		'unit_price': detail.unit_price,
		'amount': detail.amount,
	}));
};

export const formatDateDB = date => {
	if (!date) return null

    const [year, month, day] = date.substring(0, 10).split('-')
    return `${day}/${month}/${year}`
};

export const formatOrderList = orderList => {
	// { text: 'NÚMERO PEDIDO', value: 'orderNumber', align: 'center', sortable: false},
 //          { text: 'PEDIDO ID', value: 'id'},
 //          { text: 'CLIENTE ID', value: 'client_id'},
 //          { text: 'CLIENTE', value: 'client.full_name'},
 //          { text: 'FECHA DE PEDIDO', value: 'created_at' },
 //          { text: 'TOTAL DELIVERY', value: 'shipping_price' },
 //          { text: 'SUBTOTAL', value: 'subtotal' },
 //          { text: 'CUPÓN', value: 'coupon' },
 //          { text: 'TOTAL', value: 'total' },
 //          { text: 'FECHA DE DELIVERY', value: 'delivery_day' },
 //          { text: 'DELIVERY PARTNER', value: 'delivery_partner' },
 //          { text: 'ESTADO', value: 'status' },
 //          { text: 'ACCIONES', value: 'actions', filterable: false, sortable: false }

	return orderList.map(order => ({
		'orderNumber': formatOrderNumber(order.id, order.client_id),
		'id': order.id,
		'client_id': order.client_id,
		'address_id': order.address_id,
		'phone': order.client.phone,
		'full_name': order.client.full_name,
		'created_at': formatDate(order.created_at),
		'shipping_price': order.shipping_price,
		'subtotal': order.subtotal,
		'coupon': order.coupon > 0 ? `-${ order.coupon }` : '',
		'total': order.total,
		'delivery_day': formatDate(order.delivery_day),
		'status': order.status,
		'person_reception': order.person_reception,
		'name_reception': order.name_reception,
		'last_name_reception': order.last_name_reception,
		'quantity': order.quantity,
		'shipping_type_id': order.shipping_type_id,
		'delivery_partner': order.delivery_partner,
		'order_detail': order.order_detail,
		'created_at_original': order.created_at,
		'delivery_day_original': order.delivery_day,
		'coupon_code': order.coupon_code
	}));
};



// WEBPACK FOOTER //
// ./src/utils/order/index.js